import { includes } from 'lodash';
import React from 'react';
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  FacebookIcon,
  LinkedinIcon,
} from 'react-share';
import { DWTCContext } from '../utils/context';
import Sprites from './Sprites';
import { Container } from './styles/Container.styled';
import {
  SocialMediaContainer,
  ShareIconWrapper,
  SocialIconsContainer,
  ShareIconHead,
  PaddingBar,
  // ShareIconButton,
} from './styles/SocialMediaFloatingButtons.styled';

export default function SocialMediaFloatingButtons({ noPadding, dir, id }) {
  const { cssClass } = React.useContext(DWTCContext);

  const setColor = () => {
    if (includes(cssClass, 'free-zone')) return 'red';
    if (includes(cssClass, 'real-estate')) return 'green';
    return 'blue';
  };

  const [sharedUrl, setSharedUrl] = React.useState('');

  const isBrowser = typeof window !== 'undefined';

  React.useEffect(() => {
    if (isBrowser) setSharedUrl(window.location.href);
  }, []);

  return (
    <>
      <SocialMediaContainer
        id="socialMediaFloatingButtons"
        dir={dir}
        className="socialmedai_wrapper"
      >
        <Container id={id}>
          <ShareIconHead>
            <ShareIconWrapper className="shareIcon" color={setColor()} dir={dir}>
              {/* <ShareIconButton size="20" className="first" dir={dir} /> */}
              <Sprites name="share" color={setColor()} />
              <Sprites name="share-arrow" color={setColor()} />
              <SocialIconsContainer className="socialIconsContainer">
                <FacebookShareButton url={sharedUrl}>
                  <FacebookIcon className="icon facebook" />
                </FacebookShareButton>
                <LinkedinShareButton url={sharedUrl}>
                  <LinkedinIcon className="icon twitter" />
                </LinkedinShareButton>
                <TwitterShareButton url={sharedUrl}>
                  <Sprites name="twitter-x" className="icon linkedin twitter-x" />
                </TwitterShareButton>
              </SocialIconsContainer>
            </ShareIconWrapper>
          </ShareIconHead>
        </Container>
      </SocialMediaContainer>
      {noPadding || <PaddingBar id="padding_bar" />}
    </>
  );
}
